
<template>
    
        <mars-view @click.native="joinUs"><mars-image id="join" class="join-card" src="https://lvlin-base.cdn.bcebos.com/law/pages/select/card.png" mode="widthFix" :preview="false" :data-area="fr + '_show'" data-serverid="16318" :data-exts="JSON.stringify({
            fr: fr,
        })" :data-extswan="{
            fr: fr,
        }"></mars-image></mars-view>
    
</template>

<script>
import { nav } from '../../static/utils/navigate';
import { inSightObservers } from '../../common/js/repeatExposureLog.js';
export default {
  props: {
    fr: {
      'type': String,
      'default': ''
    }
  },
  mounted() {
    inSightObservers('#join', '', {}, [], true, true, true);
  },
  methods: {
    /**
     * 加入我们
     */

    joinUs() {
      nav({
        url: `/pages/settlement/marketingpage?fr=${this.fr}`
      });
    }
  }
};
</script>

<style scoped>
.join-card {
  width: 100%;
  border-radius: 12px;
}

</style>
